/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table, TableBody } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React, { useEffect, useState } from 'react';
import { ERR_GENERIC_LATER } from '../../../constants/response-error-messages';
import { GetLocalDeliveryData } from '../../../hooks/purchase-history-hooks';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { TableSkeleton } from '../../shared/skeletons/TableSkeleton';
import NoOrdersView from '../NoOrdersView';
import { ODTableHeader, ODTableRow } from './index';
import { ODTableHeaderValues } from './ODTableHeaderData';
import { ODTablePagination } from './ODTablePagination';
export var ODTable = function (_a) {
    var _b, _c, _d;
    var customerType = _a.customerType, orders = _a.orders;
    var _e = usePurchaseHistoryContext(), localDeliveryData = _e.localDeliveryData, localDeliveryError = _e.localDeliveryError, localDeliveryLoaded = _e.localDeliveryLoaded, setLocalDeliveryInfo = _e.setLocalDeliveryInfo, lDRequest = _e.lDRequest, localDeliveryAlertState = _e.localDeliveryAlertState, setLocalDeliveryAlertState = _e.setLocalDeliveryAlertState, setOpenAddReceiptDrawer = _e.setOpenAddReceiptDrawer, dateSelectorValue = _e.dateSelectorValue;
    var _f = useState({ 0: 0 }), selected = _f[0], setSelected = _f[1];
    var _g = useState(false), ldDataRendered = _g[0], setLdDataRendered = _g[1];
    var tableHeaderState = useState(ODTableHeaderValues())[0];
    var data = GetLocalDeliveryData(lDRequest);
    if (data.localDeliveryLoaded &&
        setLocalDeliveryInfo &&
        ldDataRendered === false) {
        setLocalDeliveryInfo({
            localDeliveryData: data.localDeliveryData,
            localDeliveryError: data.localDeliveryError,
            localDeliveryLoaded: data.localDeliveryLoaded,
        });
        setLdDataRendered(true);
    }
    var totalNumberOfLocalDeliveries = (_b = localDeliveryData === null || localDeliveryData === void 0 ? void 0 : localDeliveryData.orderCount) !== null && _b !== void 0 ? _b : 0;
    useEffect(function () {
        var _a;
        if (((_a = localDeliveryError === null || localDeliveryError === void 0 ? void 0 : localDeliveryError.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
            setLocalDeliveryAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: "We're sorry, there is a technical error. Please try again later.",
                status: 'error',
            });
            return;
        }
        if (localDeliveryError) {
            setLocalDeliveryAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: ERR_GENERIC_LATER.message,
                status: 'error',
            });
        }
    }, [localDeliveryError]);
    if (localDeliveryError) {
        return (React.createElement("div", { className: "sui-col-span-1" }, localDeliveryAlertState && (React.createElement(AlertBanner, { headline: localDeliveryAlertState === null || localDeliveryAlertState === void 0 ? void 0 : localDeliveryAlertState.alertTitle, status: (localDeliveryAlertState === null || localDeliveryAlertState === void 0 ? void 0 : localDeliveryAlertState.status) || 'info', onClose: localDeliveryAlertState === null || localDeliveryAlertState === void 0 ? void 0 : localDeliveryAlertState.onClose }, localDeliveryAlertState === null || localDeliveryAlertState === void 0 ? void 0 : localDeliveryAlertState.alertMessage))));
    }
    if (localDeliveryLoaded &&
        (totalNumberOfLocalDeliveries === 0 ||
            ((_c = localDeliveryData === null || localDeliveryData === void 0 ? void 0 : localDeliveryData.orders) === null || _c === void 0 ? void 0 : _c.length) === 0)) {
        return (React.createElement(ErrorBoundary, { name: "no-local-deliveries" },
            React.createElement(NoOrdersView, { customerType: customerType, setOpenAddReceiptModal: setOpenAddReceiptDrawer, activeFilter: dateSelectorValue === 'last6Months' })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-overflow-x-scroll sui-mb-5" },
            React.createElement(Table, { unlined: true, layout: "fixed", density: "loose", className: "sui-shadow-none sui-w-full" },
                React.createElement(ODTableHeader, { tableHeaderState: tableHeaderState }),
                React.createElement(TableBody, null, localDeliveryLoaded ? (orders === null || orders === void 0 ? void 0 : orders.map(function (order, index) { return (React.createElement(ODTableRow, { index: index, order: order, selected: selected, customerType: customerType, setSelected: setSelected, orderLength: orders.length })); })) : (React.createElement(TableSkeleton, { colSpan: (_d = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState.length) !== null && _d !== void 0 ? _d : 7 }))))),
        ((localDeliveryData === null || localDeliveryData === void 0 ? void 0 : localDeliveryData.orderCount) || 0) > 0 && React.createElement(ODTablePagination, null)));
};
